/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.SecurityRolesManager {

    interface ISecurityAttribute {
        childKeyIds: string[];
        children: ISecurityAttribute[];
        hierarchyMaterialized: string;
        hierarchySequenceId: string;
        id: string;
        isKeyValueChanged: boolean;
        level: number;
        parentId: string;
        roleId: string;
        securityAccess: Model.SecurityAccessEnum;
        sequence: number;
        parentPermission: Model.SecurityAccessEnum;
        displayName?: string;
        display?: boolean;
        expanded?: boolean;
    }

    interface IUserRoles {
        id: string;
        displayName: string;
        securityAttributes: ISecurityAttribute[];
        entityVersion: string;
    }
    interface ISecurityManager {
        securityAttributes: ISecurityAttribute[];
        userRoles: IUserRoles[];
    }

    interface IHierarchyLevel {
        id: string;
        value: string;
    }

    declare let XLSX: any;
    export class SecurityRolesManagerContext {

        public addSecurityModuleDetail: Model.DataDetail;
        public addUserSecurityRoleDetail: Model.DataDetail;

        public selectedModules: string[] = [];
        public selectedRoles: string[] = [];

        public excludeModules: Model.DataDetail[] = [];
        public excludeRoles: Model.DataDetail[] = [];

        public loadModules: Model.DataDetail[] = [];
        public searchTerm: any;
        managerGrid: ISecurityManager = {
            securityAttributes: [],
            userRoles: []
        };
        keyLink: any;
        changedGrid: any = {};
        expandedAttributes = [];
        public showFilters = true;
        // TODO: Determine if we are controlling form state in security manager.
        mode: Meevo.Model.MaintenanceFormState;
        private backup: any;
        public dirtyUserRoles: number[] = [];

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService) {

            this.mode = Meevo.Model.MaintenanceFormState.Readonly;
            this.loadAllModules(false);
        }

        private _manageCoOnly: boolean;
        get manageCoOnly(): boolean {
            return this._manageCoOnly;
        };
        set manageCoOnly(value: boolean) {
            // When no data loaded, change value and exit
            if (this.selectedModules.length === 0 && this.selectedRoles.length === 0)
                this._manageCoOnly = value;
            else {
                // Only process and update value if agreed
                var message = value ? "MESSAGE_ENABLE_CO_ONLY" : "MESSAGE_DISABLE_CO_ONLY";
                this.modalService.confirmHandler(message, Components.Modal.ModalTranslationModes.Translate)
                    .then(result => {
                        if (result) {

                            // Reset the matrix and cached lo
                            this.managerGrid = {securityAttributes: [], userRoles: []};
                            this.selectedModules = [];
                            this.selectedRoles = [];
                            this.excludeModules = [];
                            this.excludeRoles = [];

                            // Updated value
                            this._manageCoOnly = value;
                            this.loadAllModules(value);
                        }
                    });
            }
        };

        private _roleSelectionCriteria: any = {
            coFilterByLocationId: this.identityService.current().locationId,
            isForCoOnly: false,
            requireFullAccessUser: false,
            coSearchType: Model.CoSearchType.Location,
            coSearchResultFilter: Model.CoSearchResultsFilter.LocationOwned
        };
        get roleSelectionCriteria(): any {
            let isLocationCo = this.identityService.current().centralOfficeId == this.identityService.current().locationId;
            this._roleSelectionCriteria.isCo = isLocationCo;
            this._roleSelectionCriteria.isForCoOnly = (isLocationCo && this.manageCoOnly) ? 1 : 0;
            this._roleSelectionCriteria.requireFullAccessUser = this.identityService.current().fullAccess ? null : false;
            this._roleSelectionCriteria.coSearchType = isLocationCo ? Model.CoSearchType.CentralOffice : Model.CoSearchType.Location;
            this._roleSelectionCriteria.coSearchResultFilter = isLocationCo ? Model.CoSearchResultsFilter.All : Model.CoSearchResultsFilter.LocationOwned;

            return this._roleSelectionCriteria;
        }

        private _moduleSelectionCriteria: any = { isForCoOnly: false }; get moduleSelectionCriteria(): any {
            this._moduleSelectionCriteria.isForCoOnly = this.manageCoOnly;
            return this._moduleSelectionCriteria;
        }

        private updateManagerGrid(allRoles: boolean = false, allModules: boolean = false) {
            let params: any = {
                moduleKeys: this.selectedModules,
                roleKeys: this.selectedRoles,
                allModules: allModules,
                allRoles: allRoles,
                isForCOUseOnly: this.manageCoOnly
            };
            this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/SecurityManager/`, 'POST', params)
                .then(response => {

                    var t0 = performance.now();
                    // Must have security attributes in response
                    if (Model.Guard.isNothing(response.data.securityAttributes))
                        return;

                    this.busyService.start();
                    // Get all previous expanded key ids
                    var firstLoad = Model.Guard.isNothing(this.managerGrid.securityAttributes);
                    if (firstLoad) {
                        // First load
                        this.expandedAttributes = _.pluck(_.where(response.data.securityAttributes, { level: 1 }), "id");
                    }
                    else {
                        this.expandedAttributes = _.pluck(_.where(this.managerGrid.securityAttributes, { expanded: true }), "id");
                    }

                    /*
                     * Build and Preserve UI state (Expanded Items)
                     */
                    _.each(response.data.securityAttributes, (k: any) => {
                        k.expanded = !firstLoad && _.contains(this.expandedAttributes, k.id); // when not first load and previously expanded
                        var isRoot = (k.level === 1); // when root 
                        var previouslyExpanded = _.contains(this.expandedAttributes, k.id); // when previously expanded
                        var parentExpanded = _.find(response.data.securityAttributes, (p: any) => { return p.id === k.parentId && p.expanded === true }) !== undefined; // when parent was epanded
                        k.display = isRoot || previouslyExpanded || parentExpanded;
                    });

                    this.managerGrid.securityAttributes = response.data.securityAttributes;
                    if (allModules) {
                        this.selectedModules = _.pluck(this.managerGrid.securityAttributes, 'id');
                    }
                    this.excludeModules = _.map(this.managerGrid.securityAttributes, (attrib: any) => { return { id: attrib.id, displayName: attrib.displayName }; });

                    // Build Roles
                    if (Model.Guard.isSomething(response.data.userRoles)) {
                        if (Model.Guard.isNothing(this.managerGrid.userRoles)) {
                            // On first load assign userRoles from response
                            this.managerGrid.userRoles = response.data.userRoles;
                        } else {
                            if ((response.data.userRoles.length === 1) && allRoles) {
                                if (this.isAllRole(response.data.userRoles[0])) {
                                    this.modalService.alert('MESSAGE_IF_NO_LOCAL_ROLE', Components.Modal.ModalTranslationModes.Translate);
                                    return;
                                }
                            }
                            _.each(response.data.userRoles, (role: any) => {
                                // Update the ALL role - Returned from the server with attributes ordered
                                if (this.isAllRole(role)) {
                                    this.managerGrid.userRoles.splice(0, 1);
                                    this.managerGrid.userRoles.splice(0, 0, role);
                                    return;
                                }
                                // Find existing role
                                var existingRole: any = _.find(this.managerGrid.userRoles, (i: any) => { return Model.Guard.isSomething(i) && i.id === role.id });
                                if (Model.Guard.isSomething(existingRole)) {
                                    existingRole.securityAttributes.forEach(oldSecurityAttribute => {
                                        let newSecurityAttribute = _.find(role.securityAttributes, (att: any) => att.id === oldSecurityAttribute.id);
                                        if (newSecurityAttribute) {
                                            newSecurityAttribute.securityAccess = oldSecurityAttribute.securityAccess;
                                        }
                                    });
                                    existingRole.securityAttributes = role.securityAttributes;
                                }
                                else {
                                    // Add new role
                                    this.managerGrid.userRoles.push(role);
                                }
                            });
                        }

                        // Sort attribute hierarchy
                        _.each(this.loadedRoles(), (role: any) => {
                            role.securityAttributes = _.sortBy(role.securityAttributes, (i: any) => { return i.hierarchySequenceId; });
                        });


                        // Updated selectedRoles to all
                        if (allRoles) {
                            this.selectedRoles = _.pluck(this.managerGrid.userRoles, 'id');
                        }
                        this.excludeRoles = _.map(this.managerGrid.userRoles, (attrib: any) => { return { id: attrib.id, displayName: attrib.displayName }; });
                    }

                    // Establish links
                    this.keyLink = {};
                    _.each(this.managerGrid.securityAttributes, (k: any) => {
                        this.keyLink[k.id] = k;
                    });

                    var t1 = performance.now();

                    console.log("Call to doSomething took " + (t1 - t0) + " milliseconds.")

                }).catch(() => {
                    this.busyService.stop();
                }).finally(() => {
                    this.busyService.stop();
                    let that = this
                    setTimeout(function () {
                        var contentWidth = angular.element('#srm-content-wrapper-width');
                        var headerWidth = angular.element('#header-scroll-width');
                        var wrapperWidth = angular.element('#srm-width-marker').width();
                        contentWidth.width(170 * that.managerGrid.userRoles.length);
                        headerWidth.width(170 * that.managerGrid.userRoles.length);

                        /* Apply parent/child rules to expanded security attributes roles */
                        if (!that.expandedAttributes.length) return;
                        var tStartP = performance.now();
                        that.loadedRoles().forEach(role => {
                            const attributes = role.securityAttributes.filter(sa => that.expandedAttributes.indexOf(sa.id) > -1);
                            attributes.forEach(attr => {
                                that.updateChildKeys(attr, role);
                            })
                        });
                        var tEndP = performance.now();
                        console.log("Expanded Loaded Roles  => " + (tEndP - tStartP) + " milliseconds.")
                    })

                });
        }

        loadAllModules(forCoOnly: boolean) {
            this.addSecurityModuleDetail = null;
            this.loadModules = [];
            this.dataService.getListPaged(`/securitymanagermoduleselection/`, { itemsPerPage: 10000, criteria: { isForCoOnly: forCoOnly } })
                .then(response => {
                    this.loadModules = response;
                });
        }

        clearSearchTerm = function () {
            this.searchTerm = '';
        };

        toggleFilters = () => {
            this.showFilters = !this.showFilters
        }

        canSave(): boolean {
            return !!this.dirtyUserRoles.length;
        }

        changedUserRoles(): IUserRoles[] {
            let updates: IUserRoles[] = []
            this.dirtyUserRoles.forEach(ur => {
                var userRole = angular.copy(this.managerGrid.userRoles[ur]);
                userRole.securityAttributes = userRole.securityAttributes.filter(sa => sa.isKeyValueChanged);
                updates.push(userRole);
            })

            return updates;
        }

        save(): void {

            let params: any = {
                userRoles: this.changedUserRoles()
            };

            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.SecurityRolesManagerPage, Model.VerbEnum.SaveButtonClicked, null, null));
            this.busyService.start();
            this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/SecurityManager/`, 'PUT', params)
                .then(response => {
                    if (Model.Guard.isSomething(response.data) && response.data.length > 0) {
                        // Iterate through response of roles and update entity version values
                        _.each(response.data, (r: any) => {
                            var role = _.find(this.managerGrid.userRoles, (ur: any) => ur.id === r.id);
                            if (Model.Guard.isSomething(role)) {
                                role.entityVersion = r.entityVersion;
                                role.securityAttributes.map(attr => attr.isKeyValueChanged = false);
                            }
                        });
                    }
                    this.dirtyUserRoles = [];
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        addModule(moduleDetail: Model.DataDetail) {
            if (Model.Guard.isNothing(moduleDetail)) {
                this.modalService.alert("MESSAGE_MUST_SELECT_FEATURE", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            if (!this.selectedModules.find(i => i === moduleDetail.id)) {
                this.selectedModules.push(moduleDetail.id);
                this.addSecurityModuleDetail = null;
                this.updateManagerGrid();
            }
        }

        addAllModules() {
            this.updateManagerGrid(false, true);
        }

        addRole(roleDetail: Model.DataDetail) {
            if (Model.Guard.isNothing(roleDetail)) {
                this.modalService.alert("MESSAGE_MUST_SELECT_ROLE", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            if (Model.Guard.isNothing(this.selectedModules) || this.selectedModules.length < 1) {
                this.modalService.alert("MESSAGE_MUST_LOAD_FEATURES", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            if (!this.selectedRoles.find(r => r === roleDetail.id)) {
                this.selectedRoles.push(roleDetail.id);
                this.addUserSecurityRoleDetail = null;
                this.updateManagerGrid();
                
            }
            
        }

        addAllRoles() {
            if (Model.Guard.isNothing(this.selectedModules) || this.selectedModules.length < 1) {
                this.modalService.alert("MESSAGE_MUST_LOAD_FEATURES", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            this.updateManagerGrid(true, false);
        }

        get locationId(): number {
            return this.identityService.current().locationId;
        }

        loadedRoles(): IUserRoles[] {
            return _.filter(this.managerGrid.userRoles, ur => !this.isAllRole(ur));
        }

        showRole(role: IUserRoles): boolean {
            return !this.isAllRole(role) || this.managerGrid.userRoles.length > 2;
        }

        isAllRole(role: IUserRoles): boolean {
            return role.displayName === "ALL";
        }

        deleteItem(role: IUserRoles) {
            // Remove id and detail from cache
            this.selectedRoles.splice(_.indexOf(this.selectedRoles, role.id), 1);
            var indexRole = _.findIndex(this.excludeRoles, (r: any) => r.id === role.id);
            this.excludeRoles.splice(indexRole, 1);
            // Remove role from manager
            var indexGrid = _.findIndex(this.managerGrid.userRoles, (r: any) => r.id === role.id);
            this.dirtyUserRoles = this.dirtyUserRoles.filter(r => r !== indexGrid);
            this.managerGrid.userRoles.splice(indexGrid, 1);
        }

        expand(key: ISecurityAttribute) {

            if (key.expanded == true) {
                this.collapse(key);
                return;
            }
            if (!key.level) key.level = 1;
            key.expanded = true;
            _.each(key.childKeyIds, (c: any) => {
                var childKeyObject = this.keyLink[c];
                childKeyObject.display = true;
                childKeyObject.level = key.level + 1;
            })

            this.loadedRoles().forEach(role => {
                const attr = role.securityAttributes.find(sa => sa.id === key.id)
                this.updateChildKeys(attr, role);
            });

            setTimeout(() => {
                angular.element("#scroller-sizer").css("height", angular.element(".key-tree").css("height"));
            });

        }

        collapse(key: any) {
            key.expanded = false;
            _.each(key.childKeyIds, (c: any) => {
                var childKeyObject = this.keyLink[c];
                childKeyObject.display = false;
                this.collapse(childKeyObject);
            })

            window.setTimeout(() => {
                angular.element("#scroller-sizer").css("height", angular.element(".key-tree").css("height"));
            });
        }

        assignToChildren(key: ISecurityAttribute, role: IUserRoles) {

            key.isKeyValueChanged = true;
            this.updateChildKeys(key, role, true);

            if (this.isAllRole(role)) {
                this.changeToEffectRow(key, key.securityAccess);
            } else {
                var userRoleIndex = this.managerGrid.userRoles.findIndex(ur => ur.id === role.id);
                this.dirtyUserRoles = this.dirtyUserRoles.filter(id => id !== userRoleIndex);
                this.dirtyUserRoles.push(userRoleIndex);
            }
        }

        deleteChildren(keyId: any, parentId: any, securityAttrib: any) {
            if (Model.Guard.isSomething(parentId)) {
                var attributeIndex = securityAttrib.findIndex(item => item.id === parentId);
                if (attributeIndex < 0) {
                    attributeIndex = securityAttrib.findIndex(item => item.parentId == parentId);
                }
                var keyIndex = securityAttrib[attributeIndex].childKeyIds.indexOf(keyId);
                var keyItemIndex = securityAttrib[attributeIndex].children.findIndex(child => child.id === keyId);
                securityAttrib[attributeIndex].childKeyIds.splice(keyIndex, 1);
                securityAttrib[attributeIndex].children.splice(keyItemIndex, 1);

                if (securityAttrib[attributeIndex].childKeyIds.length <= 0) {
                    securityAttrib.splice(attributeIndex, 1);
                }
            }
            return securityAttrib;
        }

        deleteRows(keyToRemove: any, keyId: any, parentId: any) {

            this.managerGrid.securityAttributes = this.deleteChildren(keyId, parentId, this.managerGrid.securityAttributes);
            this.managerGrid.securityAttributes = this.managerGrid.securityAttributes.filter(a => a.hierarchyMaterialized.indexOf(keyToRemove) < 0);

            if (this.managerGrid.securityAttributes.length > 0)
                angular.forEach(this.managerGrid.userRoles,
                    (value, key) => {
                        this.managerGrid.userRoles[key].securityAttributes =
                            value.securityAttributes.filter(a => a.hierarchyMaterialized.indexOf(keyToRemove) < 0);
                        this.managerGrid.userRoles[key].securityAttributes = this.deleteChildren(keyId,
                            parentId,
                            this.managerGrid.userRoles[key].securityAttributes);
                    });
            else {
                this.managerGrid.userRoles = null;
            }

            this.selectedModules = _.pluck(this.managerGrid.securityAttributes, 'id');
            this.excludeModules = _.map(this.managerGrid.securityAttributes, (attrib: any) => { return { id: attrib.id, displayName: attrib.displayName }; });
            window.setTimeout(() => {
                angular.element("#scroller-sizer").css("height", angular.element(".key-tree").css("height"));
            });
        }

        /**
         * Update role child keys permissions rules i.e. Grant => Grant|Deny|Hide  Deny => Deny|Hide  Hide => Hide
         */
        public updateChildKeys(key: ISecurityAttribute, role: IUserRoles, hasChanged = false) {
            if (!key.childKeyIds) {
                return;
            }
            key.childKeyIds.forEach(id => {
                var childKey = role.securityAttributes.find(sa => sa.id == id);
                childKey.parentPermission = key.securityAccess;
                if (childKey.parentPermission !== Model.SecurityAccessEnum.Grant && childKey.securityAccess !== Model.SecurityAccessEnum.Hide) {
                    childKey.securityAccess = key.securityAccess;
                    if (hasChanged) {
                        childKey.isKeyValueChanged = true;
                        this.updateChildKeys(childKey, role, hasChanged);
                    }
                }
            });

            if (hasChanged) {
                const roleIndex = _.findIndex(this.managerGrid.userRoles, (r: any) => r.id === role.id);
                this.managerGrid.userRoles[roleIndex] = role;
            }
            
        }

        changeToEffectRow(key: any, securityAccess: any) {
            this.dirtyUserRoles = [];
            this.loadedRoles().forEach(role => {
                var childKey = role.securityAttributes.find(sa => sa.id == key.id);
                // Always update if parent permission is greater than, or equal to, changing access
                if (childKey.parentPermission >= securityAccess || Model.Guard.isNothing(childKey.parentPermission)) {
                    childKey.securityAccess = securityAccess;
                    childKey.isKeyValueChanged = true;
                    this.updateChildKeys(childKey, role, true);
                    var userRoleIndex = this.managerGrid.userRoles.findIndex(ur => ur.id === role.id);
                    this.dirtyUserRoles.push(userRoleIndex);
                }
            });
        }

        cancel() {
            // Reset/Clear features and roles so that user can re-select
            this.managerGrid = {securityAttributes: [], userRoles: []};
            this.selectedModules = [];
            this.selectedRoles = [];
            this.excludeModules = [];
            this.excludeRoles = [];
            this.dirtyUserRoles = [];
        }

        exportSecurityKeys(): void {
            if (this.canSave()) {
                this.modalService.alert('MESSAGE_PLEASE_SAVE_CHANGES_BEFORE_PROCEEDING', Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            const data = [];
            const rows = this.managerGrid.securityAttributes.filter(attr => !!attr.display);
            let headers = ['SequenceId', ...this.managerGrid.userRoles.map(role => role.displayName).filter(displayName => displayName !== 'ALL')];
            let hierarchy: IHierarchyLevel[] = [];

            rows.forEach(row => {
                let record = {};
                let name = '';
                let sequence = row.hierarchySequenceId.split('/');

                for (let i = 1; i < sequence.length - 1; i++) {
                    let temp = ''
                    if (Model.Guard.isNothing(hierarchy[i])) {
                        hierarchy[i] = { id: sequence[i], value: row.displayName }
                        temp = row.displayName;
                    } else {
                        if (sequence[i] === hierarchy[i].id) {
                            temp = hierarchy[i].value;
                        } else {
                            hierarchy[i] = { id: sequence[i], value: row.displayName }
                            temp = row.displayName;
                        }
                    }
                    name = Model.Guard.isSomething(name) ? name + '>' + temp : temp; 
                }

                this.managerGrid.userRoles.forEach(role => {
                    const attr = role.securityAttributes.find(attr => attr.id === row.id);
                    record[role.displayName] = role.displayName === 'ALL' ? name : Model.SecurityAccessEnum[attr.securityAccess];
                })
                data.push(record);
            })

            try {
                _.defer(() => { Meevo.Components.Common.DataExportService.exportToCsv(data, 'security.csv', headers) });
            } catch (e) {
                alert(`Couldn't export data file ${e}`);
            }
        }

    }
}